export const environment = {
  production: true,
  url_api: 'https://service.futuredata.com.br',
  url_api_br: 'https://service-br.futuredata.com.br',
  url_api_v2: 'https://api.futuredata.com.br'
};
